/* Etsy review wall.
   Reputon's storefront endpoint is public and CORS-open, so we can read the
   real feed and render it as our own cards rather than embedding their widget.
   Everything degrades quietly: any failure leaves the served fallback copy and
   the Etsy link in place rather than showing an error to a shopper. */
(function () {
  var root = document.querySelector('[data-dns-etsy-wall]');
  if (!root) return;

  var grid = root.querySelector('[data-dns-etsy-grid]');
  var status = root.querySelector('[data-dns-etsy-status]');
  var ratingEl = root.querySelector('[data-dns-etsy-rating]');
  var countEl = root.querySelector('[data-dns-etsy-count]');
  var highlights = root.querySelector('[data-dns-etsy-highlights]');
  var highlightList = root.querySelector('[data-dns-etsy-highlight-list]');

  var shop = root.getAttribute('data-shop');
  var max = parseInt(root.getAttribute('data-max'), 10) || 24;
  if (!shop) return;

  var ENDPOINT = 'https://etsy.reputon.com/app/storefront/widget?shop=' + encodeURIComponent(shop);

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* Whole stars filled, remainder outlined — matches snippets/dns-stars. */
  function stars(rating) {
    var wrap = el('span', 'dns-etsy__stars');
    wrap.setAttribute('aria-label', rating + ' out of 5');
    wrap.setAttribute('role', 'img');
    for (var i = 1; i <= 5; i++) {
      var s = el('span', 'dns-etsy__star' + (i <= Math.round(rating) ? ' is-on' : ''));
      s.setAttribute('aria-hidden', 'true');
      s.textContent = '★';
      wrap.appendChild(s);
    }
    return wrap;
  }

  function card(review) {
    var item = el('article', 'dns-etsy__card');
    item.setAttribute('role', 'listitem');
    var rule = el('div', 'dns-etsy__card-rule');

    var top = el('div', 'dns-etsy__card-top');
    top.appendChild(stars(review.rating || 5));
    if (review.relativeTimeDescription) {
      top.appendChild(el('span', 'dns-etsy__when', review.relativeTimeDescription));
    }
    rule.appendChild(top);

    if (review.text) {
      rule.appendChild(el('p', 'dns-etsy__quote', review.text));
    }

    var foot = el('div', 'dns-etsy__card-foot');
    if (review.authorName) {
      foot.appendChild(el('span', 'dns-etsy__author', review.authorName));
    }
    if (review.purchaseName) {
      var bought = el('span', 'dns-etsy__bought', review.purchaseName);
      foot.appendChild(bought);
    }
    rule.appendChild(foot);

    item.appendChild(rule);
    return item;
  }

  fetch(ENDPOINT, { credentials: 'omit' })
    .then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function (data) {
      var d = (data && data.reviewsData) || {};
      var reviews = (d.reviews || []).filter(function (r) {
        return r && !r.hide && r.text;
      });

      if (typeof d.rating === 'number' && ratingEl) {
        ratingEl.textContent = d.rating.toFixed(1);
      }

      /* Round DOWN to the nearest thousand and say "over", so the copy stays
         true as the count keeps climbing rather than going stale the moment
         another review lands. */
      if (d.reviewsNumber && countEl) {
        var n = Number(d.reviewsNumber);
        if (n >= 1000) {
          var floored = Math.floor(n / 1000) * 1000;
          countEl.textContent = 'from over ' + floored.toLocaleString('en-US') + ' reviews';
        } else {
          countEl.textContent = 'from ' + n.toLocaleString('en-US') + ' reviews';
        }
      }

      var items = (d.summary && d.summary.items) || [];
      if (items.length && highlightList && highlights) {
        items.forEach(function (text) {
          var li = document.createElement('li');
          li.textContent = String(text).replace(/[;.\s]+$/, '');
          highlightList.appendChild(li);
        });
        highlights.hidden = false;
      }

      if (!reviews.length) {
        if (status) status.hidden = true;
        return;
      }

      var frag = document.createDocumentFragment();
      reviews.slice(0, max).forEach(function (r) {
        frag.appendChild(card(r));
      });
      grid.appendChild(frag);
      if (status) status.hidden = true;
    })
    .catch(function () {
      /* Leave the served rating and the Etsy link doing their job. */
      if (status) status.hidden = true;
    });
})();
